module.exports = __webpack_public_path__ + "img/icon_map_default_c.7207bde7.png";